import { OrganisationGroup } from '../../../../common/api/spidertracks-sdk/private/services/UserService';

export const getMembersNotInGroupsForRecipients = (
  selectedMemberIds: string[],
  selectedGroupIds: string[],
  organisationGroups: OrganisationGroup[]
) => {
  let membersInAdminGroup: string[] = [];
  if (selectedGroupIds.includes('*')) {
    return [];
  }
  if (selectedGroupIds.includes('ADMINS')) {
    membersInAdminGroup = organisationGroups
      .filter(organisationGroup => organisationGroup.type === 'ADMINS')
      .flatMap(organisationGroup => organisationGroup.members?.map(member => member?.id) || []);
  }
  const membersInGroups = selectedGroupIds?.flatMap(
    selectedGroupId =>
      organisationGroups
        .find(orgGroup => orgGroup.id === selectedGroupId)
        ?.members?.map(member => member.id) || []
  );
  return selectedMemberIds
    .filter(selectedMemberId => !membersInAdminGroup.includes(selectedMemberId))
    .filter(selectedMemberId => !membersInGroups.includes(selectedMemberId));
};
